<template>
  <div>
    <b-label
      v-if="props.label"
      :for="props.id || props.name"
      :label="props.label"
      class="block text-sm/6 font-medium"
    />
    <div>
      <textarea
        :id="props.id || props.name"
        :name="props.name"
        :autocomplete="props.autocomplete"
        :required="props.required"
        :placeholder="props.placeholder"
        :readonly="props.readonly"
        :rows="props.rows"
        :class="[
          'w-full bg-transparent text-sm focus-within:outline-2 focus-within:border-primary focus:outline-none px-3 py-2 border border-[#373737] rounded-lg placeholder-gray-500 text-gray-300',
          {
            'text-gray-400 cursor-not-allowed': props.disabled,
          },
        ]"
        v-bind="$attrs"
        :value="props.modelValue"
        @input="onInput"
        :disabled="props.disabled"
      ></textarea>
    </div>
    <div v-if="props.description" class="text-gray-500 mt-2 text-sm">
      {{ props.description }}
    </div>
  </div>
</template>

<script setup lang="ts">
import BLabel from "~/components/forms/BLabel.vue";

defineOptions({
  inheritAttrs: false
});

interface Props {
  required?: boolean;
  autocomplete?: string;
  name?: string;
  id?: string;
  placeholder?: string;
  label?: string;
  rows?: string | number;
  description?: string;
  modelValue?: string;
  readonly?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), { rows: 5 });
const emit = defineEmits(["update:modelValue"]);

const onInput = (event: InputEvent) => {
  emit("update:modelValue", (event.target as HTMLInputElement).value);
};
</script>
